module.exports = __webpack_public_path__ + "images/favicon-6007f5e33c914ff533420a0aef319e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/favicons/favicon.png
// module id = 740
// module chunks = 0